import { Box, IconButton, type Theme, Tooltip } from '@mui/material';
import { useIntl } from 'react-intl';
import { Fullscreen } from 'lucide-react';
import { TbRulerMeasure } from 'react-icons/tb';
import { useRecoilState } from 'recoil';
import {
    scaleDisplayEnabledState,
    zoomToCursorState,
} from '~/state/atoms/toolsAtoms';

const toggleButtonSx = (active: boolean) => (theme: Theme) => ({
    width: 28,
    height: 28,
    borderRadius: 1,
    color: active ? theme.palette.primary.main : theme.palette.text.primary,
    backgroundColor: active ? 'rgba(25, 118, 210, 0.12)' : 'transparent',
    '&:hover': {
        backgroundColor: theme.palette.action.hover,
    },
    '& svg': {
        width: '100%',
        height: '100%',
        fontSize: 'inherit',
    },
});

export default function PanToolOptions() {
    const [zoomToCursor, setZoomToCursor] = useRecoilState(zoomToCursorState);
    const [scaleDisplayEnabled, setScaleDisplayEnabled] = useRecoilState(
        scaleDisplayEnabledState
    );
    const intl = useIntl();

    const zoomToCursorLabel = intl.formatMessage({
        id: 'toolbar.navigation.zoomToCursor.tooltip',
    });
    const scaleOverlayLabel = intl.formatMessage({
        id: 'toolbar.navigation.scaleOverlay.tooltip',
    });

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 0.5,
            }}
        >
            <Tooltip title={zoomToCursorLabel} placement="bottom">
                <IconButton
                    size="small"
                    aria-label={zoomToCursorLabel}
                    aria-pressed={zoomToCursor}
                    onClick={() => setZoomToCursor(!zoomToCursor)}
                    sx={toggleButtonSx(zoomToCursor)}
                >
                    <Fullscreen />
                </IconButton>
            </Tooltip>
            <Tooltip title={scaleOverlayLabel} placement="bottom">
                <IconButton
                    size="small"
                    aria-label={scaleOverlayLabel}
                    aria-pressed={scaleDisplayEnabled}
                    onClick={() => setScaleDisplayEnabled(!scaleDisplayEnabled)}
                    sx={toggleButtonSx(scaleDisplayEnabled)}
                >
                    <TbRulerMeasure />
                </IconButton>
            </Tooltip>
        </Box>
    );
}
